export default "dist/images/components-design-separator-control-wave-1.fe7d2e5.png";